import {range} from 'src/shared/utils/array-utils';

export function getFondNumberColor(colorNum: number, lightness: number): string {
    if (colorNum === 0) {
        return `hsl(0, 0%, ${lightness}%)`;
    }

    const hues = range(0, 360, 10);
    const goldenFrac = 0.5 * (3 - Math.sqrt(5));
    const x = (simpleHash(colorNum) * goldenFrac % 1.0) * (hues.length - 1);
    const i = Math.floor(x);
    const f = x % 1.0;
    const hue = (1.0 - f) * hues[i] + f * hues[i + 1];

    return `hsl(${Math.round(hue * 100) / 100}, 100%, ${lightness}%)`;
}

function simpleHash(num: number): number {
    const prime = 31;
    let hash = 7;

    const numStr = num.toString();

    for (let i = 0; i < numStr.length; i++) {
        hash = (hash * prime + numStr.charCodeAt(i)) % Number.MAX_SAFE_INTEGER;
    }

    return hash;
}